import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import AppAndSiteChannel from './AppAndSiteChannel';

import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  onChange: (targeting: TargetingBaseType) => void;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function AppAndSiteChannelWrapper({ onChange, targeting, user, userRoles }: Props) {
  return (
    <TargetingProvider onChange={onChange} targeting={targeting} user={user} userRoles={userRoles}>
      <AppAndSiteChannel />
    </TargetingProvider>
  );
}

export default AppAndSiteChannelWrapper;
